<h4 class="primary" style="display: inline-block;">{{'send_receive.send_receive.step_three.item_specification' | translate}}</h4>
<label class="tooltipSource"><img class="information-icon"
        src="/assets/icons/i_information@3x.png" />
        <a tabindex="0"></a><span>{{'buy_postage.item_specification_tooltip' | translate}}</span></label>
<div *ngFor="let type of itemTypes; let i=index">
    <app-item-type [itemType]="type" [countries]="countries" [index]="i" (delete)="deleteItemType(i)"></app-item-type>
</div>
<div class="item-type-container">
    <button class="primary-button" (click)="addItemType()">{{'buy_postage.addItemType' | translate}}</button>
</div>  